import { Button } from '@wheely/ui-kit';
import React from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getCountryCode } from '@/modules/common/store/selectors';
import { TUpdatePersonalInfoForm } from '@/modules/driver/model/driver';
import { usePhoneCodes } from '@/shared/hooks/usePhoneCodes';
import { CountryCode } from '@/shared/models/country-code';
import { BottomButtons } from '@/shared/view/BottomButtons';
import { StepLayout } from '@/shared/view/StepLayout';
import { PhoneField } from '@src-common/view/adapters/reactHookForm/PhoneField';

import s from './styles.module.css';

type IEditPersonalInfoViewProps = {
  control: Control<TUpdatePersonalInfoForm>;
  isSubmitting?: boolean;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  onNavigateBack: () => void;
};

const EditPersonalInfoView = ({
  onSubmit,
  control,
  isSubmitting,
  onNavigateBack,
}: IEditPersonalInfoViewProps) => {
  const intl = useIntl();
  const phoneCodes = usePhoneCodes();
  const countryCode = useSelector(getCountryCode);

  return (
    <StepLayout
      hideProgress={true}
      title={intl.formatMessage({
        defaultMessage: 'Personal info',
        id: 'sY078i',
        description: 'Edit chauffeur info screen: title',
      })}
      onClickBack={onNavigateBack}
    >
      <main className={s.wrapper}>
        <form onSubmit={onSubmit} className={s.form}>
          <PhoneField
            name="phoneNumber"
            namePhoneCode="phoneCode"
            title={intl.formatMessage({
              defaultMessage: 'Phone number',
              id: 'hFykp8',
              description: 'Update driver form: phone field',
            })}
            control={control}
            isRequired={true}
            items={phoneCodes}
            description={
              countryCode === CountryCode.France &&
              intl.formatMessage({
                defaultMessage: 'Enter phone number without 0',
                id: 'V8we6R',
                description: 'Phone field note',
              })
            }
          />

          <BottomButtons>
            <Button type="submit" disabled={isSubmitting} className={s.mainButton}>
              <FormattedMessage defaultMessage="Save" id="RT8KNi" description="Save button text" />
            </Button>
          </BottomButtons>
        </form>
      </main>
    </StepLayout>
  );
};

export type { IEditPersonalInfoViewProps };
export { EditPersonalInfoView };
